import teaAgent from './paths/tea-agent';
import progress from './paths/progress';
import accountBind from './paths/account-bind';
import sign from './paths/sign';
import wechat from './paths/wechat';
import photosWechat from './paths/photos-wechat';
import channel from './paths/channel';
import publistMessage from './paths/publish-message';
import HrAccess from './paths/HR_access';

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../pages'),
  },
  {
    path: '/error',
    name: 'error',
    component: () => import('../pages/error'),
  },
  // 只展示了404, 应该无实际用处
  {
    path: '/students/list',
    name: 'studentsList',
    component: () => import('../pages/students/list'),
  },
  // svip介绍页: /tea-info/pages?teaId=1426608338
  {
    name: 'teaInfo',
    path: '/tea-info/pages',
    component: () => import('../pages/tea-info/home'),
  },
  // svip老师 宣传海报 列表.
  {
    name: 'teaInfo',
    path: '/tea-info/list',
    component: () => import('../pages/tea-info/list'),
  },
  {
    name: 'courseSetting',
    path: '/course-setting/pages',
    component: () => import('../pages/course-setting/home'),
  },
  {
    name: 'peilianDetail',
    path: '/peilian/detail',
    component: () => import('../pages/peilian/peiliandetail.vue'),
  },
  {
    name: 'peilian',
    path: '/peilian',
    component: () => import('../pages/peilian/peilian.vue'),
  },
  {
    name: 'exception404',
    path: '*',
    component: () => import('../pages/exception/404.vue'),
  },
  ...teaAgent,
  ...progress,
  ...accountBind,
  ...sign,
  ...wechat,
  ...photosWechat,
  ...channel,
  ...publistMessage,
  ...HrAccess,
];

export default routes;
